// ==LICENSE-BEGIN==
// Copyright 2017 European Digital Reading Lab. All rights reserved.
// Licensed to the Readium Foundation under one or more contributor license agreements.
// Use of this source code is governed by a BSD-style license
// that can be found in the LICENSE file exposed on Github (readium) in the project repository.
// ==LICENSE-END==

export const URL_PARAM_PREVIOUS = "r2_PREV";
export const URL_PARAM_GOTO = "r2_GOTO";
export const URL_PARAM_GOTO_DOM_RANGE = "r2_GOTO_DOMRANGE";

export const URL_PARAM_CSS = "r2_CSS";
export const URL_PARAM_EPUBMEDIAOVERLAYS = "r2_isMO";

export const URL_PARAM_EPUBREADINGSYSTEM = "r2_ERS";

export const URL_PARAM_DEBUG_VISUALS = "r2_DEBUG";

export const URL_PARAM_REFRESH = "r2_REFRESH";

export const URL_PARAM_SESSION_INFO = "r2_SESSION_INFO";

export const URL_PARAM_HIGHLIGHTS = "r2_HIGHLIGHTS";

export const URL_PARAM_A11Y_SUPPORT_ENABLED = "r2_A11Y_SUPPORT_ENABLED";
export const URL_PARAM_CLIPBOARD_INTERCEPT = "r2_CLIPBOARD_INTERCEPT";

export const URL_PARAM_IS_IFRAME = "r2_IS_IFRAME";

export const URL_PARAM_WEBVIEW_SLOT = "r2_WEBVIEW_SLOT";

export const URL_PARAM_SECOND_WEBVIEW = "r2_SECOND_WEBVIEW";

export const FRAG_ID_CSS_SELECTOR = "r2-css-selector_";
export const FRAG_ID_CSS_SELECTOR_HYPERLINK = "r2-hyperlink_";
export const FRAG_ID_CSS_SELECTOR_ACTIVATE_LINK = FRAG_ID_CSS_SELECTOR + FRAG_ID_CSS_SELECTOR_HYPERLINK;
